"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@mui/material/Button"));
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var React = __importStar(require("react"));
var react_1 = require("react");
var DropDownMenu = function (_a) {
    var children = _a.children, buttonContent = _a.buttonContent, _b = _a.horizontalAlignment, horizontalAlignment = _b === void 0 ? 'left' : _b, buttonProps = __rest(_a, ["children", "buttonContent", "horizontalAlignment"]);
    var menuTarget = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    var openDropDownMenu = function () {
        setOpen(true);
    };
    var closeDropDownMenu = function () {
        setOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(Button_1.default, __assign({ onClick: openDropDownMenu }, buttonProps, { ref: menuTarget }), buttonContent)),
        React.createElement(Menu_1.default, { onClick: closeDropDownMenu, id: "simple-menu", anchorEl: menuTarget.current, anchorOrigin: { horizontal: horizontalAlignment, vertical: 'bottom' }, transformOrigin: { horizontal: horizontalAlignment, vertical: 'top' }, open: open, onClose: closeDropDownMenu }, children)));
};
exports.default = DropDownMenu;
